"use client";

import PopularLocationCard from "@/components/PopularLocationCard";
import SectionHeader from "@/components/SectionHeader";
import Swiper from "@/components/swiper";
import TabSwitcher from "@/components/TabSwitcher";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import Image from "next/image";
import React, { useState } from "react";
import { SwiperSlide } from "swiper/react";

function HotelPopularLocations(props) {
  const t = useTranslationDetector("hotel");
  const [activeTab, setActiveTab] = useState("popularEuropeanCountries");
  return (
    <div>
      <SectionHeader
        title={t("popularHotelCountriesDestinations")}
        className="mb-6"
      />
      <TabSwitcher
        className="mb-6"
        tabs={[
          { id: "popularEuropeanCountries", label: t("EuropeanDestinationsSectionTitle") },
          { id: "popularAsianCountries", label: t("AsianDestinationsSectionTitle") },
          { id: "popularAfricaCountries", label: t("AfricanDestinationsSectionTitle") },
          { id: "popularAmericaCountries", label: t("AmericanDestinationsSectionTitle") },
        ]}
        selected={activeTab}
        onChange={setActiveTab}
      />
      <Swiper
        key={activeTab}
        swiperOptions={{
          slidesPerView: "auto",
          pagination: false,
          navigation: false,
        }}
      >
        {props?.stats[activeTab]?.map((data, index) => {
          return (
            <SwiperSlide
              key={index}
              className="swiper-aspect-1-5 sm:swiper-aspect-4-5 lg:swiper-aspect-5"
            >
              <PopularLocationCard item={data} />

            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

export default HotelPopularLocations;
